import {createTheme, PaletteMode} from '@mui/material';

const FONT_STACK = "'Atkinson Hyperlegible', 'Liberation Sans', system-ui, sans-serif";

export const getTheme = (mode: PaletteMode) =>
    createTheme({
        palette: {
            mode,
            primary: {
                main: '#B08D5B',
                contrastText: '#1A1D24',
            },
            secondary: {
                main: '#1A1D24',
                contrastText: '#F8F4EC',
            },
            background: {
                default: mode === 'dark' ? '#1A1D24' : '#F8F4EC',
                paper:   mode === 'dark' ? '#22252D' : '#FFFFFF',
            },
            text: {
                primary:   mode === 'dark' ? '#F8F4EC' : '#1A1D24',
                secondary: mode === 'dark' ? 'rgba(248,244,236,0.7)' : 'rgba(26,29,36,0.6)',
            },
        },
        typography: {
            fontFamily: FONT_STACK,
            fontSize: 16 * 1.3,
            h1: { fontSize: '2.2rem', fontWeight: 500 },
            h2: { fontSize: '1.8rem', fontWeight: 500 },
            h3: { fontSize: '1.6rem', fontWeight: 500 },
            body1: { fontSize: '1rem' },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontSize: '1rem',
                        padding: '12px 24px',
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    root: { fontSize: '1.2rem' },
                },
            },
            MuiTextField: {
                defaultProps: { size: 'medium' },
            },
        },
    });
